
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/dubai-housekeeping",
      function () {
        return require("private-next-pages/case-study/dubai-housekeeping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/dubai-housekeeping"])
      });
    }
  